module.exports = __webpack_public_path__ + "static/media/bulb.0c8991bc.svg";